module.exports = __webpack_public_path__ + "static/media/building3.c3ad593c.png";